(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    (window.programmingKeyUpgradeConfig || []).forEach(setupInstance);
  }

  // The scanner/key variants on the programming-key-service product only
  // decide WHICH scanner + key combinations are valid and what to show.
  // What actually goes into the cart is the universal key variant from
  // the `programming-keys` product (matched by SKU) — the same five
  // variants the programming-keys-selector sells on scanner pages — so
  // the SKU on the order line is one of these five, and the scanner
  // travels only as a line item property, never as part of the SKU.
  //
  // Keyed by the product's "Keys" option value (lowercased, trimmed).
  var KEY_TO_UNIVERSAL_SKU = {
    'dmr': 'SCANNERKEYDMR',
    'provoice': 'SCANNERKEYPV',
    'nxdn': 'SCANNERKEYNXDN',
    'waterfall key': 'SCANNERKEYWATERFALL',
    'extreme upgrade': 'SCANNERKEYHP'
  };

  function normKey(s) { return String(s || '').trim().toLowerCase(); }
  function normSku(s) { return String(s || '').trim().toUpperCase(); }

  // Pairs each scanner/key variant with the universal variant it is sold
  // as. A pairing that can't be resolved is dropped (and logged) rather
  // than offered, so a shopper can never pick a key that can't be added
  // to the cart. The price shown and charged is the universal variant's,
  // since that is the variant that actually goes into the cart.
  function resolveVariants(scannerVariants, universalVariants) {
    var universalBySku = {};
    universalVariants.forEach(function (u) { universalBySku[normSku(u.sku)] = u; });

    var resolved = [];
    scannerVariants.forEach(function (v) {
      var universalSku = KEY_TO_UNIVERSAL_SKU[normKey(v.key)];
      var universal = universalSku ? universalBySku[universalSku] : null;

      if (!universal) {
        console.error(
          'programming-key-upgrade-selector: no universal variant for key "' + v.key +
          '" (scanner ' + v.scanner + ', SKU ' + v.sku + '). Expected SKU ' +
          (universalSku || '<no mapping in KEY_TO_UNIVERSAL_SKU>') +
          ' on the programming-keys product. Hiding this option.'
        );
        return;
      }

      if (Number(universal.price) !== Number(v.price)) {
        console.warn(
          'programming-key-upgrade-selector: price mismatch for ' + v.scanner + ' / ' + v.key +
          ' — service variant is ' + v.price + ', universal ' + universal.sku + ' is ' +
          universal.price + '. The shopper is shown and charged the universal price.'
        );
      }

      v.universal = universal;
      v.chargePrice = Number(universal.price);
      resolved.push(v);
    });
    return resolved;
  }

  function setupInstance(config) {
    var root = document.querySelector(config.rootSelector);
    if (!root) return;

    if (!window.ProductAddonsCore) {
      console.error('programming-key-upgrade-selector: ProductAddonsCore not found — make sure product-addons-core.js loads first');
      return;
    }

    var scannerSelect = root.querySelector('[data-programming-key-upgrade-scanner]');
    var keysContainer = root.querySelector('[data-programming-key-upgrade-keys]');
    var errorEl = root.querySelector('[data-programming-key-upgrade-error]');
    var variants = resolveVariants(config.variants || [], config.universalVariants || []);
    var selectedVariantIds = {}; // variantId -> true; reset whenever scanner changes

    var esnInput = root.querySelector('[data-programming-key-upgrade-esn]');
    var esnErrorEl = root.querySelector('[data-programming-key-upgrade-esn-error]');
    var checksumInput = root.querySelector('[data-programming-key-upgrade-checksum]');
    var checksumErrorEl = root.querySelector('[data-programming-key-upgrade-checksum-error]');
    var serialInput = root.querySelector('[data-programming-key-upgrade-serial]');
    var serialErrorEl = root.querySelector('[data-programming-key-upgrade-serial-error]');

    // { input, errorEl, pattern, message } — one entry per required field.
    var identifierFields = [
      { input: esnInput, errorEl: esnErrorEl, pattern: /^\d{14}$/, message: 'ESN must be exactly 14 digits, numbers only.' },
      { input: checksumInput, errorEl: checksumErrorEl, pattern: /^[A-Za-z0-9]{3}$/, message: 'Check Sum # must be exactly 3 characters, letters or numbers.' },
      { input: serialInput, errorEl: serialErrorEl, pattern: /^\d{8}$/, message: 'Serial # must be exactly 8 digits, numbers only.' }
    ];

    identifierFields.forEach(function (field) {
      if (!field.input) return;
      field.input.addEventListener('blur', function () {
        validateField(field, false); // only show an error once they've actually typed something and left the field
      });
      field.input.addEventListener('input', function () {
        if (!field.errorEl.hidden) validateField(field, false); // clear the error live once it's corrected
      });
    });

    function validateField(field, silent) {
      if (!field.input) return true;
      var value = field.input.value.trim();
      var isValid = field.pattern.test(value);

      if (isValid || (silent && value === '')) {
        field.errorEl.textContent = '';
        field.errorEl.hidden = true;
      } else {
        field.errorEl.textContent = field.message;
        field.errorEl.hidden = false;
      }
      return isValid;
    }

    if (!variants.length) {
      showError('Programming key options are not configured correctly. Contact support.');
      console.error('programming-key-upgrade-selector: no variants resolved — check the addon product handle and its Scanner/Keys options, and that the programming-keys product has the SCANNERKEY* variants');
      window.ProductAddonsCore.register(root, function () {
        showError('Programming key options are not configured correctly. Contact support.');
        return { ok: false };
      });
      return;
    }

    populateScanners();

    scannerSelect.addEventListener('change', function () {
      selectedVariantIds = {};
      renderKeys(scannerSelect.value);
      clearError();
      if (window.ProductAddonsCore && window.ProductAddonsCore.notifyChange) window.ProductAddonsCore.notifyChange(root);
    });

    window.ProductAddonsCore.register(root, getContribution, getPriceContribution);

    function populateScanners() {
      var scanners = [];
      variants.forEach(function (v) {
        if (scanners.indexOf(v.scanner) === -1) scanners.push(v.scanner);
      });
      scanners.sort(function (a, b) { return a.localeCompare(b); });

      scanners.forEach(function (scanner) {
        var option = document.createElement('option');
        option.value = scanner;
        option.textContent = scanner;
        scannerSelect.appendChild(option);
      });
    }

    function renderKeys(scanner) {
      keysContainer.innerHTML = '';
      if (!scanner) return;

      var matching = variants.filter(function (v) { return v.scanner === scanner; });

      matching.forEach(function (variant) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'product__chip';
        chip.dataset.variantId = String(variant.variantId);
        chip.setAttribute('aria-pressed', 'false');
        chip.textContent = variant.key + ' (+' + formatMoney(variant.chargePrice) + ')';
        chip.addEventListener('click', function () {
          var isNowSelected = !selectedVariantIds[variant.variantId];
          if (isNowSelected) {
            selectedVariantIds[variant.variantId] = true;
          } else {
            delete selectedVariantIds[variant.variantId];
          }
          chip.classList.toggle('selected', isNowSelected);
          chip.setAttribute('aria-pressed', isNowSelected ? 'true' : 'false');
          clearError();
          if (window.ProductAddonsCore && window.ProductAddonsCore.notifyChange) window.ProductAddonsCore.notifyChange(root);
        });
        keysContainer.appendChild(chip);
      });
    }

    // Live price preview only — no validation, no error UI. The ESN/
    // Check Sum/Serial fields don't affect price, so they're irrelevant
    // here; only the selected key chips matter.
    function getPriceContribution() {
      var total = 0;
      variants.forEach(function (v) {
        if (selectedVariantIds[v.variantId]) total += Number(v.chargePrice);
      });
      return total;
    }

    // Called by ProductAddonsCore when the shopper clicks add-to-cart.
    // The scanner/key selection itself stays optional — but the moment
    // at least one key is selected, the three identifier fields become
    // required, since they identify the specific physical scanner unit
    // that needs to be programmed.
    //
    // Each selected key becomes its OWN separate cart line, added as the
    // universal key variant from the programming-keys product (see
    // KEY_TO_UNIVERSAL_SKU) — so if two keys are selected, each is priced
    // and added independently rather than combined into one line, and the
    // SKU on each order line is the universal one, not a scanner-specific
    // one. The scanner is carried as a line property only. The universal
    // SKU is also included as a visible line property so it shows up
    // directly in order admin/emails without needing to look up the
    // variant separately.
    function getContribution() {
      var selectedVariants = variants.filter(function (v) { return selectedVariantIds[v.variantId]; });

      if (selectedVariants.length === 0) {
        clearError();
        return { ok: true, items: [] }; // nothing selected: fully optional, nothing to validate
      }

      var allValid = true;
      identifierFields.forEach(function (field) {
        if (!validateField(field, true)) allValid = false;
      });

      if (!allValid) {
        showError('Please fix the highlighted field(s) below before adding to cart.');
        root.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return { ok: false };
      }

      var esn = esnInput ? esnInput.value.trim() : '';
      var checksum = checksumInput ? checksumInput.value.trim() : '';
      var serial = serialInput ? serialInput.value.trim() : '';

      var items = selectedVariants.map(function (v) {
        return {
          id: v.universal.variantId,
          quantity: 1,
          properties: {
            'Scanner': v.scanner,
            'Key': v.key,
            'SKU': v.universal.sku,
            'ESN': esn,
            'Check Sum #': checksum,
          }
        };
      });

      clearError();
      return { ok: true, items: items };
    }

    function showError(msg) { errorEl.textContent = msg; errorEl.hidden = false; }
    function clearError() { errorEl.textContent = ''; errorEl.hidden = true; }
    function formatMoney(amount) { return '$' + Number(amount).toFixed(2); }
  }
})();